import axiosInstance from '../axiosInstance'
import { Url } from './constantUrl'
import getHeaders from './getHeaders'
import * as types from './types'
import { errorHandler } from './error/errorHandler.action'

export const orderviewAction = (id, sort, column) => dispatch => {
  const API_URL = localStorage.getItem('countryBackendUrl')
  let url = `${API_URL}${Url.ORDER_VIEW_LIST}/${id}`;

  if (sort && column) {
    url += `?order_by=${column}&order=${sort}`;
  }

  const options = {
    method: 'GET',
    headers: getHeaders(),
    url
  };
    return axiosInstance(options).then(resp => {
      if (resp.status === 200 || resp.status === 201) {
        dispatch({ type: types.GET_ORDER_VIEW_LIST, payload: resp?.data })
        return resp
      } else { return null }
    })
      .catch(error => {
        errorHandler(error)
      })
  }
  